//
//
//
//
//
//
//

import RbAnimatedGlasses from '@/elements/animated-glasses/rb-animated-glasses.vue'
import animationData from '@/assets/images/animated-glasses.json'

export default {
  name: 'rb-loading',
  components: {
    RbAnimatedGlasses,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      defaultOptions: { animationData: animationData },
    }
  },
}
